import { z } from 'zod'
import { GameType } from '@/modules/promotion/type'
import { CalculateInterval } from '@/schema'
import { walletConditionSchema } from '@/common/components/WalletConditionSection'

const gameTypeSettingsSchema = z.object({
	creditRatio: z
		.number()
		.min(0, 'เปอร์เซ็นต์จ่ายเครดิตต้องมากกว่าหรือเท่ากับ 0')
		.optional()
		.nullable(),
	maxCreditAmount: z
		.number()
		.min(0, 'เครดิตสูงสุดต้องมากกว่าหรือเท่ากับ 0')
		.optional()
		.nullable(),
})

export const CALCULATE_INTERVALS = [
	{ value: 'DAILY', label: 'ทุก 1 วัน' },
	{ value: 'WEEKLY', label: 'ทุก 7 วัน (คิดทุกวันอาทิตย์)' },
	{ value: 'MONTHLY', label: 'ทุกเดือน (คิดทุกวันที่ 1 ของเดือน)' },
] as const

export const returnLossFormSchema = z.object({
	name: z.string().min(1, 'กรุณากรอกชื่อโปรโมชั่น'),
	isActive: z.boolean(),
	minimumLossAmount: z
		.number()
		.min(0, 'ยอดเสียขั้นต่ำต้องมากกว่าหรือเท่ากับ 0'),
	creditRatio: z.record(z.nativeEnum(GameType), gameTypeSettingsSchema),
	calculateInterval: z.nativeEnum(CalculateInterval),
	hasExpiration: z.boolean(),
	walletCondition: walletConditionSchema.optional(),
})

export type ReturnLossFormValues = z.infer<typeof returnLossFormSchema>
